<template>
	<div
		:class="['common-item', widthType === 'wide' ? 'common-item-wide' : 'common-item-narrow']"
		@click="handleClick"
	>
		<div class="item-image-container">
			<img class="item-image" :src="item.image || item.logo43" alt="" />
		</div>
		<div class="item-content">
			<p class="item-content-title text-overflow2">{{ item.title }}</p>
			<p class="item-content-time" v-if="isShowTime">{{ formatDate(item.time) }}</p>
		</div>
	</div>
</template>

<script>
import dayjs from 'dayjs';
export default {
	name: 'CommonItem',
	props: {
		// 数据项
		item: {
			type: Object,
			required: true,
			default: () => ({})
		},
		// 点击链接字段名，默认为 'url'，也可以是 'descUrl' 等
		urlField: {
			type: String,
			default: 'url'
		},
		isShowTime: {
			type: Boolean,
			default: true
		},
		widthType: {
			type: String,
			default: 'wide' // wide, narrow
		}
	},
	methods: {
		handleClick() {
			const url = this.item[this.urlField];
			if (!url) return;
			window.open(url, '_blank');
		},
		formatDate(time) {
			return dayjs(time).format('YYYY-MM-DD');
		}
	}
};
</script>

<style scoped lang="less">
@device-width-mobile: 760px;
.common-item {
	cursor: pointer;

	.item-image-container {
		position: relative;
		width: 100%;

		.item-image {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			object-fit: cover;
			object-position: 0 0;
		}
	}

	.item-content {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		height: 116px;
		padding: 16px;
		background: #f4f4f4;
		.item-content-title {
			color: var(--investors-osl-color-black);
			font-size: 16px;
			font-weight: 500;
			line-height: 28px; /* 175% */

			word-break: break-word !important;
			text-align: justify !important;
		}
		.item-content-time {
			padding-top: 12px;
			color: rgba(var(--investors-osl-color-black-rgb), 0.4);
			font-size: 12px;
			font-weight: 400;
			line-height: 16px; /* 133.333% */
		}
	}
}
.common-item-wide {
	.item-image-container {
		padding-top: 56.25%; /* 9 / 16 = 0.5625 */
	}
}
.common-item-narrow {
	.item-image-container {
		padding-top: 100%; /* 1 / 1 = 1 */
	}
	.item-content {
		height: 90px;
	}
}

@media (max-width: @device-width-mobile) {
	.common-item-wide {
		width: 100%;
		.item-image {
			height: 188px;
		}
		.item-content {
			height: 112px !important;
		}
	}
	.common-item-narrow {
		width: 100%;
		.item-image {
			height: 335px;
		}
		.item-content {
			height: 84px !important;
		}
	}

	.item-content {
		.item-content-title {
			font-size: 14px !important;
			line-height: 26px !important;
			overflow: hidden;
			text-overflow: ellipsis;
			word-break: break-all;
			display: -webkit-box;
			-webkit-line-clamp: 2 !important;
			-webkit-box-orient: vertical;
		}
	}
}
</style>
